import { render, staticRenderFns } from "./SigninView.vue?vue&type=template&id=35f0873f&"
import script from "./SigninView.vue?vue&type=script&lang=js&"
export * from "./SigninView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports